<template>
    <div id="app">
        <div class="page__wrapper">
            <!-- page header start -->
            <page-header/>
            <!-- page header end  -->
            <div id="top"></div>
            <eye-able></eye-able>
            <!-- page content start -->
            <transition
                name="fade-page"
                mode="out-in"
                @after-leave="triggerScroll()"
            >
                <keep-alive>
                    <router-view @scroll-to="triggerScroll"/>
                </keep-alive>
            </transition>
            <!-- page content end -->
            <!-- mobile code box start -->
            <code-box :mobile="true"/>
            <!-- mobile code box end -->
            <!-- page footer start -->
            <page-footer/>
            <!-- page footer end -->
        </div>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'

import PageHeader from '@/components/PageHeader'
import PageFooter from '@/components/PageFooter'
import CodeBox from '@/components/CodeBox'
import EyeAble from './components/EyeAble.vue'

export default {
    name: 'App',
    // use components
    components: {
        PageHeader,
        PageFooter,
        CodeBox,
        EyeAble
    },

    beforeMount () {
        this.$store.dispatch('fetchProjects')
    },

    methods: {
        triggerScroll (target) {
            const selector = target || this.$route.hash || '#top'
            const options = {
                container: 'body',
                easing: 'ease-out',
                offset: -100,
                force: true
            }

            this.$nextTick().then(() => {
                VueScrollTo.scrollTo(selector, 500, options)
            })
        }
    }
}
</script>

<style lang="scss">
@import "./scss/index.scss";

.fade-page-enter-active,
.fade-page-leave-active {
  transition: opacity 0.5s;
}

.fade-page-enter, .fade-page-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue